/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import 'react-app-polyfill/stable';

import './style/custom.scss';
import './js/util/startup';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {AppContextProvider} from "./js/components/misc/appContext";
import AdminContextProvider from "./js/components/misc/adminContext";
import {Routes} from "./js/routes";
import {createBrowserRouter, RouterProvider} from 'react-router';
import {getSetting} from '@dvrd/dvr-controls';
import './style/primereact-theme/themes/mytheme/theme.scss'
import 'primereact/resources/primereact.css'


const router = createBrowserRouter(Routes);

const rootElement = document.getElementById('content');
if (rootElement) {
    createRoot(rootElement).render(
        <AppContextProvider>
            <AdminContextProvider>
                <RouterProvider router={router}/>
            </AdminContextProvider>
        </AppContextProvider>
    );
}